export var badgeStyle = function (bg) { return ({
    backgroundColor: bg,
    color: '#fff',
    borderRadius: '3px',
    padding: '1px 6px',
    fontSize: '0.75rem',
    whiteSpace: 'nowrap',
}); };
/**
 * Green only for the goal state (the form shows the ontology's name). Amber for a
 * template override — visible, but NOT an error: several properties legitimately
 * project onto one tag (CZNA-371). Red for the two that want fixing: a redundant
 * copy that will go stale, and a name the ontology is missing entirely.
 */
export var SOURCE_COLOR = {
    ONTOLOGY: '#128000',
    TEMPLATE_OVERRIDE: '#b06000',
    TEMPLATE_REDUNDANT: '#c00',
    ONTOLOGY_MISSING: '#c00',
    // Legitimate by design (frontend-only input) — grey, not a defect to chase.
    FORM_ONLY: '#5a6b7d',
    TEMPLATE_BLANK: '#c00',
    NO_LABEL_ANYWHERE: '#c00',
};
